<template lang="pug">
v-container(class='pa-0')
  v-layout(row wrap)
    v-flex(xs12)
      v-text-field(
        v-model='coordinates'
        hint='Нажмите на карту, или перемещайте маркер, чтобы выбрать расположение'
        prepend-icon='outlined_flag'
        persistent-hint
        disabled
        label='Координаты'
      )
    v-flex(xs12)
      div(ref='yamap' class='yamap d-flex align-center')
        v-progress-circular(
          v-if='mapIsLoading'
          indeterminate
          color='primary'
        )
</template>

<script>
import { loadScript } from '@/utils'
import { isNumber, isString } from 'lodash'

let isNumeric = val => {
  return (
    (isNumber(val) || (isString(val) && Boolean(val.trim()))) && isFinite(val)
  )
}

export default {
  props: ['lat', 'lon'],

  data: () => ({
    mapIsLoading: true
  }),

  beforeDestroy() {
    clearTimeout(this.mapTimer)

    if (this.map) {
      this.map.destroy()
    }
  },

  methods: {
    loadMap() {
      this.mapIsLoading = true

      loadScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU', () => {
        // eslint-disable-next-line
        ymaps.load(() => {
          if (this.mapTimer) {
            clearTimeout(this.mapTimer)
          }
          this.mapTimer = setTimeout(() => {
            if (!this._isDestroyed) {
              this.createMap.apply(this, arguments)
              this.mapIsLoading = false
            }
          }, 100)
        })
      })
    },

    createMap() {
      // eslint-disable-next-line
      this.map = new ymaps.Map(
        this.$refs.yamap,
        {
          center: [55.796289, 49.108795],
          controls: ['searchControl'],
          zoom: 15
        },
        {
          searchControlProvider: 'yandex#search'
        }
      )

      this.initEvents()
    },

    initEvents() {
      let vm = this

      // Создаем пустую метку
      this.placemark = createPlacemark([0, 0])

      // Слушаем событие окончания перетаскивания на метке
      this.placemark.events.add('dragend', () => {
        let coords = this.placemark.geometry.getCoordinates()

        emitGeography({ coords })
        getAddress(coords, emitGeography)
      })

      // Добавим метку на карту
      this.map.geoObjects.add(this.placemark)

      // Сразу передвинем метку, если у нас уже есть координаты
      let { lat, lon } = this
      if (isNumeric(lat) && isNumeric(lat)) {
        this.placemark.geometry.setCoordinates([lat, lon])
        this.map.setCenter([lat, lon])

        getAddress(this.placemark.geometry.getCoordinates(), emitGeography)
      }

      this.map.events.add('click', async event => {
        let coords = event.get('coords')
        this.placemark.geometry.setCoordinates(coords)

        emitGeography({ coords })
        getAddress(coords, emitGeography)
      })

      function emitGeography({ address, coords }) {
        let [lat, lon] = coords

        if (address) {
          vm.$emit('change', {
            address,
            coords
          })
        }

        vm.$emit('update:lat', lat)
        vm.$emit('update:lon', lon)
      }

      // Создание метки
      function createPlacemark(coords, caption) {
        // eslint-disable-next-line
        return new ymaps.Placemark(
          coords,
          {
            iconCaption: caption ? caption : ''
          },
          {
            preset: 'islands#violetDotIconWithCaption',
            draggable: true
          }
        )
      }

      // Определяем адрес по координатам (обратное геокодирование)
      function getAddress(coords, callback) {
        vm.placemark.properties.set('iconCaption', 'поиск...')
        // eslint-disable-next-line
        ymaps.geocode(coords).then(res => {
          let firstGeoObject = res.geoObjects.get(0)

          // Формируем строку с данными об объекте
          let caption = [
            // Название населенного пункта или вышестоящее
            // административно-территориальное образование
            firstGeoObject.getLocalities().length
              ? firstGeoObject.getLocalities()
              : firstGeoObject.getAdministrativeAreas(),

            // Получаем путь до топонима, если метод вернул null,
            // запрашиваем наименование здания
            firstGeoObject.getThoroughfare() || firstGeoObject.getPremise()
          ]
            .filter(Boolean)
            .join(', ')

          vm.placemark.properties.set({
            iconCaption: caption,
            balloonContent: firstGeoObject.getAddressLine()
          })

          callback({ address: caption, coords })
        })
      }
    }
  },

  computed: {
    coordinates() {
      let { lat, lon } = this

      if (isNumeric(lat) && isNumeric(lon)) {
        return [lat, lon]
      }

      return null
    }
  }
}
</script>

<style scoped>
.yamap {
  height: 320px;
}
</style>
